import React from "react";
import { Modal, Button } from "react-bootstrap";
import parse from "react-html-parser";
// import './ConfirmationModel.css'

const ConfirmationModel = ({
  show,
  onHide,
  title,
  content,
  onYes,
  onNo,
  yesButtonText = "Yes",
  noButtonText = "No",
  loading = false,
  isForDelete,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        closeButton
        className="border-bottom py-3 add-agent-license"
      >
        <Modal.Title className="p-1 mb-0 add-agent-license-title roboto-regular" style={{fontSize: '20px'}}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`py-3 ${isForDelete ? "" : "text-center"}`}>
        <p className={`mb-0  my-3 ${isForDelete ? "fs-12" : ""}`} style={{color: '#333', fontSize: '14px', fontFamily: 'robotoregular'}}>
          {parse(content)}
        </p>
      </Modal.Body>
      <Modal.Footer className="text-center py-2 justify-content-center border-top-0">
        {isForDelete ? (
          <div className="text-center d-flex justify-content-center mb-2">
            <button className="delete-btn" onClick={onYes}>
              {loading ? "Processing..." : "Delete Account"}
            </button>
          </div>
        ) : (
          <>
            <Button
              variant="primary"
              size="sm"
              onClick={onYes}
              disabled={loading}
              style={{fontSize: '14px', fontFamily: 'robotolight'}}
              className=" px-3"
            >
              {loading ? "Processing..." : yesButtonText}
            </Button>
            <Button
              variant="secondary"
              size="sm"
              onClick={onNo}
              disabled={loading}
              className="px-3"
              style={{fontSize: '14px', fontFamily: 'robotolight'}}
            >
              {noButtonText}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModel;
